import { render, staticRenderFns } from "./RiskAnalysis.vue?vue&type=template&id=58d08288"
import script from "./RiskAnalysis.vue?vue&type=script&lang=js"
export * from "./RiskAnalysis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports